export default __webpack_public_path__ + "static/media/arrows-r.efc876bf.svg";